import URI from "urijs";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import useLocation from "routing/useLocation";
import useQuery from "routing/useQuery";
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZES = [10, 20, 50, 100];
const usePaginationQueryParameter = (PAGE_SIZES = DEFAULT_PAGE_SIZES, propsPageSize = DEFAULT_PAGE_SIZES[0], syncPageSizeFromQuery = true) => {
  const { page: pageQueryParameter, pageSize: pageSizeQueryParameter } = useQuery();
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const query = pathname + search;
  const pageQueryParameterAsNumber = Number(pageQueryParameter);
  const page = Number.isInteger(pageQueryParameterAsNumber) && pageQueryParameterAsNumber > 0 ? pageQueryParameterAsNumber : DEFAULT_PAGE;
  const pageSizeQueryParameterAsNumber = Number(pageSizeQueryParameter);
  const determinePageSize = () => {
    if (!syncPageSizeFromQuery) {
      return propsPageSize;
    }
    return Number.isInteger(pageSizeQueryParameterAsNumber) && (PAGE_SIZES == null ? void 0 : PAGE_SIZES.includes(pageSizeQueryParameterAsNumber)) ? pageSizeQueryParameterAsNumber : propsPageSize;
  };
  const pageSize = determinePageSize();
  const setPagination = useCallback(
    ({ page: newPage = page, pageSize: newPageSize = pageSize }) => {
      const uri = new URI(query).setSearch({
        page: newPage,
        pageSize: syncPageSizeFromQuery ? String(newPageSize) : void 0
      });
      navigate(uri.toString());
    },
    [navigate, page, pageSize, query, syncPageSizeFromQuery]
  );
  const resetPage = useCallback(() => {
    setPagination({ page: DEFAULT_PAGE });
  }, [setPagination]);
  return { page, resetPage, pageSize, setPagination };
};
export default usePaginationQueryParameter;
